import Forgot from "components/Forgot";
import React from "react";
import ForgotBanner from "components/ForgotBanner";

const ForgotPassword = () => {
  return (
    <div className=" flex fixed w-[100vw] justify-between">
      <Forgot />
      <ForgotBanner />
    </div>
  );
};

export default ForgotPassword;
